import * as Sentry from '@sentry/react'

import { baseErrorFormatter, HandleApiRequest, handleApiRequest as handleApiRequestBase } from '../../shared/apiWrapper'

// Desperately need to get standardized error responses from optimus.
// Checks for 'error', 'detail', or 'message' keys in the error response body,
// falling back to baseErrorFormatter (URL + status code) for unknown formats.
export function tryGetErrorDetail<Err>(response: Response, error?: Err): string {
    if (error && typeof error === 'object') {
        if ('error' in error && typeof error.error === 'string') {
            return error.error
        }
        if ('detail' in error && typeof error.detail === 'string') {
            // Note that the detail messages are used to determine how to handle different types of errors. For example,
            // on the tactical plan magic button press. If you change the format, please make sure to check that the
            // magic button handling still work correctly.  A better way could be to support some error codes so that
            // we don't need to hack with string messages. We could consider updating the HTTPException in the backend
            // to return detail as an object with an error code and reason fields.
            Sentry.captureException(new Error(baseErrorFormatter(response, error)))
            return baseErrorFormatter(response, error)
        }
        if ('message' in error && typeof error.message === 'string') {
            return error.message
        }
    }

    return baseErrorFormatter(response, error)
}

// Wrapper function
export async function handleApiRequest<T, Err>(apiCall: HandleApiRequest<T, Err>['apiCall']): Promise<T | undefined> {
    return handleApiRequestBase({ apiCall, options: { errorFormatter: tryGetErrorDetail } })
}
